import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './components/pages/home/home.component';
import {AboutusComponent} from './components/pages/aboutus/aboutus.component';
import {VisionandmissionComponent} from './components/pages/visionandmission/visionandmission.component';
import {ActandstatutesComponent} from './components/pages/actandstatutes/actandstatutes.component';
import {BoardofresearchComponent} from './components/pages/boardofresearch/boardofresearch.component';
import {AffiliationsComponent} from './components/pages/affiliations/affiliations.component';
import {ChancellorComponent} from './components/pages/chancellor/chancellor.component';
import {VicechancellorComponent} from './components/pages/vicechancellor/vicechancellor.component';
import {DeanacademicComponent} from './components/pages/deanacademic/deanacademic.component';
import {RegistrarComponent} from './components/pages/registrar/registrar.component';
import {DeanrdComponent} from './components/pages/deanrd/deanrd.component';
import {CommitteesComponent} from './components/pages/committees/committees.component';
import {DswComponent} from './components/pages/dsw/dsw.component';
import {AntiraggComponent} from './components/pages/antiragg/antiragg.component';
import {ProgrammesComponent} from './components/pages/programmes/programmes.component';
import {PlacementComponent} from './components/pages/placement/placement.component';
import {InfrastructureComponent} from './components/pages/infrastructure/infrastructure.component';
import {ResearchComponent} from './components/pages/research/research.component';
import {AdmissionofficesComponent} from './components/pages/admissionoffices/admissionoffices.component';
import {BrouchureComponent} from './components/pages/brouchure/brouchure.component';
import {AdmissionformComponent} from './components/pages/admissionform/admissionform.component';
import {AcedamiccalendarComponent} from './components/pages/acedamiccalendar/acedamiccalendar.component';
import {RefundpolicyComponent} from './components/pages/refundpolicy/refundpolicy.component';
import {
    ExtracurricullaractivitiesComponent
} from './components/pages/extracurricullaractivities/extracurricullaractivities.component';
import {IqacComponent} from './components/pages/iqac/iqac.component';
import {IqacminutesComponent} from './components/pages/iqacminutes/iqacminutes.component';
import {InitiativereportsComponent} from './components/pages/initiativereports/initiativereports.component';
import {QualitymandatesComponent} from './components/pages/qualitymandates/qualitymandates.component';
import {MoocComponent} from './components/pages/mooc/mooc.component';
import {AsthomeComponent} from './components/pages/ast/asthome/asthome.component';
import {AstsyllabusComponent} from "./components/pages/ast/astsyllabus/astsyllabus.component";
import {AstlabsComponent} from "./components/pages/ast/astlabs/astlabs.component";
import {AstcontactusComponent} from "./components/pages/ast/astcontactus/astcontactus.component";
import {AstcivilengineeringComponent} from "./components/pages/ast/astcivilengineering/astcivilengineering.component";
import {
    AstmechanicalengineeringComponent
} from "./components/pages/ast/astmechanicalengineering/astmechanicalengineering.component";
import {
    AstcomputerscienceengineeringComponent
} from "./components/pages/ast/astcomputerscienceengineering/astcomputerscienceengineering.component";
import {AsteceComponent} from "./components/pages/ast/astece/astece.component";
import {AstcybersecurityComponent} from "./components/pages/ast/astcybersecurity/astcybersecurity.component";
import {AsbmchomeComponent} from "./components/pages/asbmc/asbmchome/asbmchome.component";
import {AsbmcsyllabusComponent} from "./components/pages/asbmc/asbmcsyllabus/asbmcsyllabus.component";
import {AsbmccontactComponent} from "./components/pages/asbmc/asbmccontact/asbmccontact.component";
import {
    AsbmcbusinessstudiesComponent
} from "./components/pages/asbmc/asbmcbusinessstudies/asbmcbusinessstudies.component";
import {AsbmccommerceComponent} from "./components/pages/asbmc/asbmccommerce/asbmccommerce.component";
import {
    AsbmchotelmanagementandcateringComponent
} from "./components/pages/asbmc/asbmchotelmanagementandcatering/asbmchotelmanagementandcatering.component";
import {AsahhomeComponent} from "./components/pages/asah/asahhome/asahhome.component";
import {AsahsyllabusComponent} from "./components/pages/asah/asahsyllabus/asahsyllabus.component";
import {AsahcontactComponent} from "./components/pages/asah/asahcontact/asahcontact.component";
import {AsahenglishComponent} from "./components/pages/asah/asahenglish/asahenglish.component";
import {AsaheducationComponent} from "./components/pages/asah/asaheducation/asaheducation.component";
import {AsahlibraryscienceComponent} from "./components/pages/asah/asahlibraryscience/asahlibraryscience.component";
import {
    AsahjournalismandmasscommunicationComponent
} from "./components/pages/asah/asahjournalismandmasscommunication/asahjournalismandmasscommunication.component";
import {AsahfashiondesignComponent} from "./components/pages/asah/asahfashiondesign/asahfashiondesign.component";
import {AsahyogascienceComponent} from "./components/pages/asah/asahyogascience/asahyogascience.component";
import {
    AsahvocationalcourseComponent
} from "./components/pages/asah/asahvocationalcourse/asahvocationalcourse.component";
import {AsbsbthomeComponent} from "./components/pages/asbsbt/asbsbthome/asbsbthome.component";
import {AsbsbtsyllabusComponent} from "./components/pages/asbsbt/asbsbtsyllabus/asbsbtsyllabus.component";
import {AsbsbtcontactComponent} from "./components/pages/asbsbt/asbsbtcontact/asbsbtcontact.component";
import {
    AsbsbtphysicalscienceComponent
} from "./components/pages/asbsbt/asbsbtphysicalscience/asbsbtphysicalscience.component";
import {
    AsbsbtlifeandalliedscienceComponent
} from "./components/pages/asbsbt/asbsbtlifeandalliedscience/asbsbtlifeandalliedscience.component";
import {AsbsbtchemistryComponent} from "./components/pages/asbsbt/asbsbtchemistry/asbsbtchemistry.component";
import {AsbsbtmathsComponent} from "./components/pages/asbsbt/asbsbtmaths/asbsbtmaths.component";
import {AsahshomeComponent} from "./components/pages/asahs/asahshome/asahshome.component";
import {AsahSyllabusComponent} from "./components/pages/asahs/asah-syllabus/asah-syllabus.component";
import {AsahslabComponent} from "./components/pages/asahs/asahslab/asahslab.component";
import {AsahscontactComponent} from "./components/pages/asahs/asahscontact/asahscontact.component";
import {AsahsradiologyComponent} from "./components/pages/asahs/asahsradiology/asahsradiology.component";
import {AsahsottComponent} from "./components/pages/asahs/asahsott/asahsott.component";
import {AsahsanesthesiaComponent} from "./components/pages/asahs/asahsanesthesia/asahsanesthesia.component";
import {AsahsoptometryComponent} from "./components/pages/asahs/asahsoptometry/asahsoptometry.component";
import {AsahsmltComponent} from "./components/pages/asahs/asahsmlt/asahsmlt.component";
import {AsahsphysiotherapyComponent} from "./components/pages/asahs/asahsphysiotherapy/asahsphysiotherapy.component";
import {AsahsyogasciComponent} from "./components/pages/asahs/asahsyogasci/asahsyogasci.component";
import {AsphomeComponent} from "./components/pages/asp/asphome/asphome.component";
import {AspsyllabusComponent} from "./components/pages/asp/aspsyllabus/aspsyllabus.component";
import {AsplabComponent} from "./components/pages/asp/asplab/asplab.component";
import {AspcontactComponent} from "./components/pages/asp/aspcontact/aspcontact.component";
import {AsppharmacyComponent} from "./components/pages/asp/asppharmacy/asppharmacy.component";
import {AsahomeComponent} from "./components/pages/asa/asahome/asahome.component";
import {AsasyllabusComponent} from "./components/pages/asa/asasyllabus/asasyllabus.component";
import {AsacontactComponent} from "./components/pages/asa/asacontact/asacontact.component";
import {AsalabComponent} from "./components/pages/asa/asalab/asalab.component";
import {AsaagricultureComponent} from "./components/pages/asa/asaagriculture/asaagriculture.component";
import {AslhomeComponent} from "./components/pages/asl/aslhome/aslhome.component";
import {AslsyllabusComponent} from "./components/pages/asl/aslsyllabus/aslsyllabus.component";
import {AsllabComponent} from "./components/pages/asl/asllab/asllab.component";
import {AslcontactComponent} from "./components/pages/asl/aslcontact/aslcontact.component";
import {AsllegalstudiesComponent} from "./components/pages/asl/asllegalstudies/asllegalstudies.component";
import {AshtmhomeComponent} from "./components/pages/ashmt/ashtmhome/ashtmhome.component";
import {AshmtsyllabusComponent} from "./components/pages/ashmt/ashmtsyllabus/ashmtsyllabus.component";
import {AshmtcontactComponent} from "./components/pages/ashmt/ashmtcontact/ashmtcontact.component";
import {AshmtlabComponent} from "./components/pages/ashmt/ashmtlab/ashmtlab.component";
import {
    AshmttoursimandhospitalitymanagementComponent
} from "./components/pages/ashmt/ashmttoursimandhospitalitymanagement/ashmttoursimandhospitalitymanagement.component";
import {AseshomeComponent} from "./components/pages/ases/aseshome/aseshome.component";
import {AsessyllabusComponent} from "./components/pages/ases/asessyllabus/asessyllabus.component";
import {AseslabsComponent} from "./components/pages/ases/aseslabs/aseslabs.component";
import {AsescontactComponent} from "./components/pages/ases/asescontact/asescontact.component";
import {
    AsescomputerapplicationComponent
} from "./components/pages/ases/asescomputerapplication/asescomputerapplication.component";
import {FacultyinformationComponent} from "./components/pages/facultyinformation/facultyinformation.component";
import {NonteachingstaffComponent} from "./components/pages/nonteachingstaff/nonteachingstaff.component";
import {ScholarshipComponent} from "./components/pages/scholarship/scholarship.component";
import {HostelgalleryComponent} from "./components/pages/hostelgallery/hostelgallery.component";
import {HostelinfrastructureComponent} from "./components/pages/hostelinfrastructure/hostelinfrastructure.component";
import {BusfacilityComponent} from "./components/pages/busfacility/busfacility.component";
import {LibraryComponent} from "./components/pages/library/library.component";
import {VideogalleryComponent} from "./components/pages/videogallery/videogallery.component";
import {PhotogalleryComponent} from "./components/pages/photogallery/photogallery.component";
import {GreencampuspolicyComponent} from "./components/pages/greencampuspolicy/greencampuspolicy.component";
import {DatesheetComponent} from "./components/pages/datesheet/datesheet.component";
import {InductionprogramComponent} from "./components/pages/inductionprogram/inductionprogram.component";
import {StudentsurveyComponent} from "./components/pages/studentsurvey/studentsurvey.component";
import {ResearchunitComponent} from "./components/pages/researchunit/researchunit.component";
import {StudentinfodetailComponent} from "./components/pages/studentinfodetail/studentinfodetail.component";
import {ContactComponent} from "./components/pages/contact/contact.component";
import {CareerComponent} from "./components/pages/career/career.component";
import {NewsComponent} from "./components/pages/news/news.component";
import {EnquiryComponent} from "./components/pages/enquiry/enquiry.component";
import {BlogComponent} from "./components/pages/blog/blog.component";
import {BlogDetailComponent} from "./components/pages/blog-detail/blog-detail.component";
import {SecurityAndDisplineComponent} from "./components/pages/security-and-displine/security-and-displine.component";
import {MediaGalleryComponent} from "./components/pages/media-gallery/media-gallery.component";
import {CircularNoticeComponent} from "./components/pages/circular-notice/circular-notice.component";
import {OnlineEducationComponent} from "./components/pages/online-education/online-education.component";
import {OnlineExamComponent} from "./components/pages/online-exam/online-exam.component";
import {CafeteriaComponent} from "./components/pages/cafeteria/cafeteria.component";
import {MessComponent} from "./components/pages/mess/mess.component";
import {PrivacyPolicyComponent} from "./components/pages/privacy-policy/privacy-policy.component";
import {TermsAndConditionsComponent} from "./components/pages/terms-and-conditions/terms-and-conditions.component";
import {ConferenceComponent} from "./components/pages/conference/conference.component";
import {
    AstcomputerscienceapplicationComponent
} from "./components/pages/ast/astcomputerscienceapplication/astcomputerscienceapplication.component";

const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'about-us', component: AboutusComponent},
    {path: 'vision-and-mission', component: VisionandmissionComponent},
    {path: 'act-and-statutes', component: ActandstatutesComponent},
    {path: 'board-of-research', component: BoardofresearchComponent},
    {path: 'affiliation', component: AffiliationsComponent},
    {path: 'chancellor', component: ChancellorComponent},
    {path: 'vice-chancellor', component: VicechancellorComponent},
    {path: 'dean-academic', component: DeanacademicComponent},
    {path: 'registrar', component: RegistrarComponent},
    {path: 'deanrd', component: DeanrdComponent},
    {path: 'committees', component: CommitteesComponent},
    {path: 'dsw', component: DswComponent},
    {path: 'antiragg', component: AntiraggComponent},
    {path: 'programmes', component: ProgrammesComponent},
    {path: 'placement', component: PlacementComponent},
    {path: 'infrastructure', component: InfrastructureComponent},
    {path: 'research', component: ResearchComponent},
    {path: 'admission-offices', component: AdmissionofficesComponent},
    {path: 'brouchure', component: BrouchureComponent},
    {path: 'admission-form', component: AdmissionformComponent},
    {path: 'acedamic-calendar', component: AcedamiccalendarComponent},
    {path: 'security-discipline', component: SecurityAndDisplineComponent},
    {path: 'refund-policy', component: RefundpolicyComponent},
    {path: 'extra-curricullar-activities', component: ExtracurricullaractivitiesComponent},
    {path: 'iqac', component: IqacComponent},
    {path: 'iqac-minutes', component: IqacminutesComponent},
    {path: 'initiative-reports', component: InitiativereportsComponent},
    {path: 'quality-mandates', component: QualitymandatesComponent},
    {path: 'mooc', component: MoocComponent},
    {path: 'ast', component: AsthomeComponent},
    {path: 'ast-syllabus', component: AstsyllabusComponent},
    {path: 'ast-labs', component: AstlabsComponent},
    {path: 'ast-contactus', component: AstcontactusComponent},
    {path: 'ast-civil-engineering', component: AstcivilengineeringComponent},
    {path: 'ast-mechanical-engineering', component: AstmechanicalengineeringComponent},
    {path: 'ast-computer-science-engineering', component: AstcomputerscienceengineeringComponent},
    {path: 'ast-computer-science-application', component: AstcomputerscienceapplicationComponent},
    {path: 'ast-ece-ee', component: AsteceComponent},
    {path: 'ast-cyber-security', component: AstcybersecurityComponent},
    {path: 'asbmc', component: AsbmchomeComponent},
    {path: 'asbmc-syllabus', component: AsbmcsyllabusComponent},
    {path: 'asbmc-contactus', component: AsbmccontactComponent},
    {path: 'asbmc-business-studies', component: AsbmcbusinessstudiesComponent},
    {path: 'asbmc-commerce', component: AsbmccommerceComponent},
    {path: 'asbmc-hospitality-management', component: AsbmchotelmanagementandcateringComponent},
    {path: 'asah', component: AsahhomeComponent},
    {path: 'asah-syllabus', component: AsahsyllabusComponent},
    {path: 'asah-contact', component: AsahcontactComponent},
    {path: 'asah-english', component: AsahenglishComponent},
    {path: 'asah-education', component: AsaheducationComponent},
    {path: 'asah-library-science', component: AsahlibraryscienceComponent},
    {path: 'asah-journalism-and-mass-communication', component: AsahjournalismandmasscommunicationComponent},
    {path: 'asah-fashion-design', component: AsahfashiondesignComponent},
    {path: 'asah-yoga-science', component: AsahyogascienceComponent},
    {path: 'asah-vocational-course', component: AsahvocationalcourseComponent},
    {path: 'asbsbt', component: AsbsbthomeComponent},
    {path: 'asbsbt-syllabus', component: AsbsbtsyllabusComponent},
    {path: 'asbsbt-contact', component: AsbsbtcontactComponent},
    {path: 'asbsbt-physical-science', component: AsbsbtphysicalscienceComponent},
    {path: 'asbsbt-life-science', component: AsbsbtlifeandalliedscienceComponent},
    {path: 'asbsbt-chemistry', component: AsbsbtchemistryComponent},
    {path: 'asbsbt-maths', component: AsbsbtmathsComponent},
    {path: 'asahs', component: AsahshomeComponent},
    {path: 'asahs-syllabus', component: AsahSyllabusComponent},
    {path: 'asahs-lab', component: AsahslabComponent},
    {path: 'asahs-contact', component: AsahscontactComponent},
    {path: 'asahs-radiology', component: AsahsradiologyComponent},
    {path: 'asahs-ott', component: AsahsottComponent},
    {path: 'asahs-anesthesia', component: AsahsanesthesiaComponent},
    {path: 'asahs-optometry', component: AsahsoptometryComponent},
    {path: 'asahs-mlt', component: AsahsmltComponent},
    {path: 'asahs-physiotherapy', component: AsahsphysiotherapyComponent},
    {path: 'asahs-yogasci', component: AsahsyogasciComponent},
    {path: 'asp', component: AsphomeComponent},
    {path: 'asp-syllabus', component: AspsyllabusComponent},
    {path: 'asp-lab', component: AsplabComponent},
    {path: 'asp-contact', component: AspcontactComponent},
    {path: 'asp-pharmacy', component: AsppharmacyComponent},
    {path: 'asa', component: AsahomeComponent},
    {path: 'asa-syllabus', component: AsasyllabusComponent},
    {path: 'asa-contact', component: AsacontactComponent},
    {path: 'asa-lab', component: AsalabComponent},
    {path: 'asa-agriculture', component: AsaagricultureComponent},
    {path: 'asl', component: AslhomeComponent},
    {path: 'asl-syllabus', component: AslsyllabusComponent},
    {path: 'asl-lab', component: AsllabComponent},
    {path: 'asl-contact', component: AslcontactComponent},
    {path: 'asl-legal-studies', component: AsllegalstudiesComponent},
    {path: 'ashmt', component: AshtmhomeComponent},
    {path: 'ashmt-syllabus', component: AshmtsyllabusComponent},
    {path: 'ashmt-lab', component: AshmtlabComponent},
    {path: 'ashmt-toursim-and-Hospitality-Management', component: AshmttoursimandhospitalitymanagementComponent},
    {path: 'ashmt-contact', component: AshmtcontactComponent},
    {path: 'ases', component: AseshomeComponent},
    {path: 'ases-syllabus', component: AsessyllabusComponent},
    {path: 'ases-lab', component: AseslabsComponent},
    {path: 'ases-contact', component: AsescontactComponent},
    {path: 'ases-physical-application', component: AsescomputerapplicationComponent},
    {path: 'faculty-information', component: FacultyinformationComponent},
    {path: 'non-teaching-staff', component: NonteachingstaffComponent},
    {path: 'scholarship', component: ScholarshipComponent},
    {path: 'hostel-gallery', component: HostelgalleryComponent},
    {path: 'hostel-infrastructure', component: HostelinfrastructureComponent},
    {path: 'bus-facility', component: BusfacilityComponent},
    {path: 'library', component: LibraryComponent},
    {path: 'video-gallery', component: VideogalleryComponent},
    {path: 'photo-gallery', component: PhotogalleryComponent},
    {path: 'green-campus', component: GreencampuspolicyComponent},
    {path: 'datesheet', component: DatesheetComponent},
    {path: 'induction-program', component: InductionprogramComponent},
    {path: 'student-survey', component: StudentsurveyComponent},
    {path: 'research-unit', component: ResearchunitComponent},
    {path: 'student-info-detail', component: StudentinfodetailComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'career', component: CareerComponent},
    {path: 'news', component: NewsComponent},
    {path: 'enquiry', component: EnquiryComponent},
    {path: 'blog', component: BlogComponent},
    {path: 'blog-details', component: BlogDetailComponent},
    {path: 'media-gallery', component: MediaGalleryComponent},
    {path: 'circular-notice', component: CircularNoticeComponent},
    {path: 'online-education', component: OnlineEducationComponent},
    {path: 'online-exam', component: OnlineExamComponent},
    {path: 'cafeteria', component: CafeteriaComponent},
    {path: 'mess', component: MessComponent},
    {path: 'privacy-policy', component: PrivacyPolicyComponent},
    {path: 'terms-and-conditions', component: TermsAndConditionsComponent},
    {path: 'conference', component: ConferenceComponent},
    {path: '', redirectTo: '/', pathMatch: 'full'},
    {path: '**', redirectTo: '/'}, // Fallback for unmatched routes
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
